/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./js/components/CoverageMap.jsx"
/*!***************************************!*\
  !*** ./js/components/CoverageMap.jsx ***!
  \***************************************/
(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ CoverageMap)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/esm/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/slicedToArray */ "./node_modules/@babel/runtime/helpers/esm/slicedToArray.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_usa_map__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! react-usa-map */ "./node_modules/react-usa-map/index.js");
/* harmony import */ var react_usa_map__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react_usa_map__WEBPACK_IMPORTED_MODULE_3__);


function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
;


// Coverage type colors - matching reference site exactly
var COVERAGE_COLORS = {
  'ppo': '#8cc63f',
  // Bright Lime Green - PPO
  'hmo-ppo': '#4a9d9f',
  // Teal - HMO + PPO
  'ffs': '#f7941d',
  // Orange - FFS agreement
  'capitated-ah': '#1a3a5c',
  // Navy - Capitated AdaptHealth
  'capitated-rotech': '#0066b3',
  // Blue - Capitated Rotech
  'default': '#d1d5db' // Gray - default/no filter
};

// Muted/grayed colors when filter is not active
var GRAYED_COLOR = '#d1d5db';

// Black color for states with NO coverage at all (Alaska, Hawaii)
var UNCOVERED_COLOR = '#1a1a1a';

// States with absolutely no coverage - always black
var UNCOVERED_STATES = ['AK', 'HI'];

// State names for tooltips
var STATE_NAMES = {
  'AL': 'Alabama',
  'AK': 'Alaska',
  'AZ': 'Arizona',
  'AR': 'Arkansas',
  'CA': 'California',
  'CO': 'Colorado',
  'CT': 'Connecticut',
  'DE': 'Delaware',
  'FL': 'Florida',
  'GA': 'Georgia',
  'HI': 'Hawaii',
  'ID': 'Idaho',
  'IL': 'Illinois',
  'IN': 'Indiana',
  'IA': 'Iowa',
  'KS': 'Kansas',
  'KY': 'Kentucky',
  'LA': 'Louisiana',
  'ME': 'Maine',
  'MD': 'Maryland',
  'MA': 'Massachusetts',
  'MI': 'Michigan',
  'MN': 'Minnesota',
  'MS': 'Mississippi',
  'MO': 'Missouri',
  'MT': 'Montana',
  'NE': 'Nebraska',
  'NV': 'Nevada',
  'NH': 'New Hampshire',
  'NJ': 'New Jersey',
  'NM': 'New Mexico',
  'NY': 'New York',
  'NC': 'North Carolina',
  'ND': 'North Dakota',
  'OH': 'Ohio',
  'OK': 'Oklahoma',
  'OR': 'Oregon',
  'PA': 'Pennsylvania',
  'RI': 'Rhode Island',
  'SC': 'South Carolina',
  'SD': 'South Dakota',
  'TN': 'Tennessee',
  'TX': 'Texas',
  'UT': 'Utah',
  'VT': 'Vermont',
  'VA': 'Virginia',
  'WA': 'Washington',
  'WV': 'West Virginia',
  'WI': 'Wisconsin',
  'WY': 'Wyoming',
  'DC': 'Washington D.C.'
};

// State coverage data based on reference image
// Each state has: 1 color-determining coverage + optionally 1 capitated agreement (max 2)
var STATE_COVERAGE = {
  // FFS Only - Orange (8 states, no icons)
  'WA': ['ffs'],
  'OR': ['ffs'],
  'CA': ['ffs', 'capitated-ah'],
  'ID': ['ffs'],
  'MT': ['ffs'],
  'WY': ['ffs'],
  'UT': ['ffs'],
  'AZ': ['ffs'],
  // HMO-PPO + Capitated AdaptHealth - Teal with + icon
  'NV': ['hmo-ppo', 'capitated-ah'],
  'CO': ['hmo-ppo', 'capitated-ah'],
  'NM': ['hmo-ppo', 'capitated-ah'],
  'ND': ['hmo-ppo', 'capitated-ah'],
  'SD': ['hmo-ppo', 'capitated-ah'],
  'NE': ['hmo-ppo', 'capitated-ah'],
  'KS': ['hmo-ppo', 'capitated-ah'],
  'MN': ['hmo-ppo', 'capitated-ah'],
  'IA': ['hmo-ppo', 'capitated-ah'],
  'MO': ['hmo-ppo', 'capitated-ah'],
  'OK': ['hmo-ppo', 'capitated-ah'],
  'TX': ['hmo-ppo', 'capitated-ah'],
  'AR': ['hmo-ppo', 'capitated-ah'],
  'GA': ['hmo-ppo', 'capitated-ah'],
  'SC': ['hmo-ppo', 'capitated-ah'],
  'NC': ['hmo-ppo', 'capitated-ah'],
  'VA': ['hmo-ppo', 'capitated-ah'],
  'MD': ['hmo-ppo', 'capitated-ah'],
  'DC': ['hmo-ppo', 'capitated-ah'],
  'DE': ['hmo-ppo', 'capitated-ah'],
  'NJ': ['hmo-ppo', 'capitated-ah'],
  'NY': ['hmo-ppo', 'capitated-ah'],
  'CT': ['hmo-ppo', 'capitated-ah'],
  'RI': ['hmo-ppo', 'capitated-ah'],
  'MA': ['hmo-ppo', 'capitated-ah'],
  'VT': ['hmo-ppo', 'capitated-ah'],
  'NH': ['hmo-ppo', 'capitated-ah'],
  'ME': ['hmo-ppo', 'capitated-ah'],
  'PA': ['hmo-ppo', 'capitated-ah'],
  'AL': ['hmo-ppo', 'capitated-ah'],
  'IL': ['hmo-ppo', 'capitated-ah'],
  'TN': ['hmo-ppo', 'capitated-ah'],
  'WI': ['hmo-ppo', 'capitated-ah'],
  // PPO + Capitated Rotech - Green with R icon (8 states)
  'WV': ['ppo', 'capitated-rotech'],
  'MI': ['ppo', 'capitated-rotech'],
  'OH': ['ppo', 'capitated-rotech'],
  'IN': ['ppo', 'capitated-rotech'],
  'KY': ['ppo', 'capitated-rotech'],
  'MS': ['ppo', 'capitated-rotech'],
  'LA': ['ppo', 'capitated-rotech'],
  'FL': ['ppo', 'capitated-rotech']
  // Note: Alaska (AK) and Hawaii (HI) are excluded - no coverage
};

// Manual center offsets for states where bounding box center doesn't align with visual center
// Values are percentage offsets from the calculated center (positive = right/down)
var CENTER_OFFSETS = {
  'FL': {
    x: 3,
    y: -8
  },
  // Florida - shift up into peninsula center (away from panhandle and bottom)
  'MI': {
    x: 2,
    y: 8
  },
  // Michigan - shift down to lower peninsula center
  'LA': {
    x: -3,
    y: -4
  },
  // Louisiana - shift more LEFT and UP to center in main landmass
  'MD': {
    x: 3,
    y: 0
  },
  // Maryland - shift right to main area
  'VA': {
    x: 2,
    y: 1
  },
  // Virginia - slight adjustment
  'NY': {
    x: -5,
    y: 3
  },
  // New York - shift left toward main state area (away from Long Island)
  'MA': {
    x: -8,
    y: 2
  },
  // Massachusetts - shift more left from Cape Cod
  'TX': {
    x: 3,
    y: 0
  },
  // Texas - shift slightly right
  'CA': {
    x: 0,
    y: 3
  },
  // California - shift down
  'ID': {
    x: 0,
    y: 4
  },
  // Idaho - shift down from panhandle
  'PA': {
    x: -3,
    y: 0
  },
  // Pennsylvania - shift left
  'OH': {
    x: 0,
    y: -1
  },
  // Ohio - slight adjustment
  'NC': {
    x: 0,
    y: -1
  },
  // North Carolina - shift up slightly
  'NJ': {
    x: -4,
    y: 3
  },
  // New Jersey - shift left and down to separate from NY
  'CT': {
    x: -6,
    y: 4
  },
  // Connecticut - shift left and down significantly
  'RI': {
    x: 4,
    y: 4
  },
  // Rhode Island - shift right and down to separate
  'DE': {
    x: -5,
    y: 5
  },
  // Delaware - shift left and down
  'VT': {
    x: -3,
    y: 0
  },
  // Vermont - shift left
  'NH': {
    x: 2,
    y: 0
  },
  // New Hampshire - shift right to separate from VT
  'ME': {
    x: 0,
    y: 3
  },
  // Maine - shift down slightly
  'MS': {
    x: 0,
    y: 0
  },
  // Mississippi - keep centered
  'AR': {
    x: -2,
    y: 0
  },
  // Arkansas - shift left slightly to avoid overlap with neighbors
  'WV': {
    x: -2,
    y: 0
  },
  // West Virginia - shift left
  'DC': {
    x: -8,
    y: 6
  } // DC - shift left and down significantly (very small)
};

// Legend items - matching reference site exactly
var LEGEND_ITEMS = [{
  id: 'ppo',
  color: '#8cc63f',
  label: 'AdaptHealth is a Preferred Provider to PPO Members'
}, {
  id: 'hmo-ppo',
  color: '#4a9d9f',
  label: 'AdaptHealth is a Preferred PPO Provider + HMO Members are covered by a capitated agreement'
}, {
  id: 'ffs',
  color: '#f7941d',
  label: 'HMO and PPO Members are covered by a FFS agreement with AdaptHealth'
}, {
  id: 'capitated-ah',
  color: '#1a3a5c',
  label: 'HMO Members are covered by a capitated agreement with AdaptHealth',
  hasIcon: true
}, {
  id: 'capitated-rotech',
  color: '#0066b3',
  label: 'HMO Members are covered by a capitated agreement with Rotech',
  hasLogo: true
}];

// Priority order for color display (first match wins)
var COLOR_PRIORITY = ['ppo', 'hmo-ppo', 'ffs'];
function CoverageMap(_ref) {
  var _ref$shopifyData = _ref.shopifyData,
    shopifyData = _ref$shopifyData === void 0 ? {} : _ref$shopifyData;
  // Extract image URL from props if available
  var imageUrl = (shopifyData === null || shopifyData === void 0 ? void 0 : shopifyData.imageUrl) || null;
  var hasImage = !!imageUrl;

  // All filters always active - no toggle functionality
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(new Set(['ppo', 'hmo-ppo', 'ffs', 'capitated-ah', 'capitated-rotech'])),
    _useState2 = (0,_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_1__["default"])(_useState, 1),
    activeFilters = _useState2[0];
  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null),
    _useState4 = (0,_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_1__["default"])(_useState3, 2),
    hoveredState = _useState4[0],
    setHoveredState = _useState4[1];
  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({
      x: 0,
      y: 0
    }),
    _useState6 = (0,_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_1__["default"])(_useState5, 2),
    tooltipPos = _useState6[0],
    setTooltipPos = _useState6[1];
  var _useState7 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({}),
    _useState8 = (0,_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_1__["default"])(_useState7, 2),
    stateCenters = _useState8[0],
    setStateCenters = _useState8[1];
  var mapContainerRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);

  // Calculate state centers from SVG path bounding boxes (only if not using image)
  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {
    if (hasImage) return; // Skip if using image

    var calculateCenters = () => {
      var container = mapContainerRef.current;
      if (!container) return;
      var svg = container.querySelector('svg');
      if (!svg) return;
      var centers = {};
      var statePaths = svg.querySelectorAll('path[data-name]');
      statePaths.forEach(path => {
        var stateCode = path.getAttribute('data-name');
        if (!stateCode) return;
        try {
          var bbox = path.getBBox();

          // Center of the bounding box
          var centerX = bbox.x + bbox.width / 2;
          var centerY = bbox.y + bbox.height / 2;

          // Convert to percentages of SVG viewBox
          var viewBox = svg.viewBox.baseVal;
          var pctX = centerX / viewBox.width * 100;
          var pctY = centerY / viewBox.height * 100;
          centers[stateCode] = {
            pct: {
              x: pctX,
              y: pctY
            }
          };
        } catch (e) {
          // getBBox can fail for hidden paths
        }
      });
      setStateCenters(centers);
    };
    calculateCenters();
    window.addEventListener('resize', calculateCenters);
    return () => window.removeEventListener('resize', calculateCenters);
  }, [hasImage]);

  // Get the display color for a state based on active filters
  var getStateColor = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(stateCode => {
    // Alaska and Hawaii are always black - no coverage
    if (UNCOVERED_STATES.includes(stateCode)) {
      return UNCOVERED_COLOR;
    }
    var coverageTypes = STATE_COVERAGE[stateCode] || [];
    if (activeFilters.size === 0) {
      return GRAYED_COLOR;
    }

    // Check if state has ANY of the active filters
    var matchingTypes = coverageTypes.filter(type => activeFilters.has(type));
    if (matchingTypes.length === 0) {
      return GRAYED_COLOR;
    }

    // Find the highest priority color type that matches
    for (var priorityType of COLOR_PRIORITY) {
      if (matchingTypes.includes(priorityType)) {
        return COVERAGE_COLORS[priorityType];
      }
    }

    // Fallback for capitated-only states (show as gray since they don't have fill colors)
    return GRAYED_COLOR;
  }, [activeFilters]);

  // Generate state configurations for the map
  var statesCustomConfig = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(() => {
    var config = {};
    Object.keys(STATE_COVERAGE).forEach(stateCode => {
      config[stateCode] = {
        fill: getStateColor(stateCode),
        onMouseEnter: evt => {
          var stateName = STATE_NAMES[stateCode] || stateCode;
          var coverageTypes = STATE_COVERAGE[stateCode] || [];
          var coverageLabels = coverageTypes.map(t => {
            var _LEGEND_ITEMS$find;
            return (_LEGEND_ITEMS$find = LEGEND_ITEMS.find(item => item.id === t)) === null || _LEGEND_ITEMS$find === void 0 ? void 0 : _LEGEND_ITEMS$find.label;
          }).filter(Boolean);
          setHoveredState({
            name: stateName,
            coverages: coverageLabels
          });
        },
        onMouseMove: evt => {
          var rect = mapContainerRef.current.getBoundingClientRect();
          setTooltipPos({
            x: evt.clientX - rect.left + 10,
            y: evt.clientY - rect.top - 10
          });
        },
        onMouseLeave: () => setHoveredState(null)
      };
    });
    UNCOVERED_STATES.forEach(stateCode => {
      config[stateCode] = {
        fill: UNCOVERED_COLOR,
        onMouseEnter: evt => {
          var stateName = STATE_NAMES[stateCode] || stateCode;
          setHoveredState({
            name: stateName,
            coverages: []
          });
        },
        onMouseMove: evt => {
          var rect = mapContainerRef.current.getBoundingClientRect();
          setTooltipPos({
            x: evt.clientX - rect.left + 10,
            y: evt.clientY - rect.top - 10
          });
        },
        onMouseLeave: () => setHoveredState(null)
      };
    });
    return config;
  }, [getStateColor]);

  // Get states that should show icons
  var getIconStates = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(() => {
    var iconStates = [];
    Object.entries(STATE_COVERAGE).forEach(_ref2 => {
      var _ref3 = (0,_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_1__["default"])(_ref2, 2),
        stateCode = _ref3[0],
        coverageTypes = _ref3[1];
      var center = stateCenters[stateCode];
      if (!center) return;

      // Check for capitated-ah
      if (coverageTypes.includes('capitated-ah') && activeFilters.has('capitated-ah')) {
        iconStates.push(_objectSpread({
          stateCode,
          type: 'plus'
        }, center));
      }
      // Check for capitated-rotech
      else if (coverageTypes.includes('capitated-rotech') && activeFilters.has('capitated-rotech')) {
        iconStates.push(_objectSpread({
          stateCode,
          type: 'rotech'
        }, center));
      }
    });
    return iconStates;
  }, [activeFilters, stateCenters]);

  // Handle mouse events for tooltip (only if not using image)
  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {
    if (hasImage) return; // Skip if using image

    var container = mapContainerRef.current;
    if (!container) return;
    var handleMouseMove = e => {
      var stateEl = e.target.closest('path[data-name]');
      if (stateEl) {
        var stateCode = stateEl.getAttribute('data-name');
        var stateName = STATE_NAMES[stateCode] || stateCode;
        var coverageTypes = STATE_COVERAGE[stateCode] || [];

        // Tooltip includes coverage types ONLY for state hover
        var coverageLabels = coverageTypes.map(type => {
          var _LEGEND_ITEMS$find2;
          return (_LEGEND_ITEMS$find2 = LEGEND_ITEMS.find(item => item.id === type)) === null || _LEGEND_ITEMS$find2 === void 0 ? void 0 : _LEGEND_ITEMS$find2.label;
        }).filter(Boolean);
        setHoveredState({
          name: stateName,
          coverages: coverageLabels
        });
        var rect = container.getBoundingClientRect();
        setTooltipPos({
          x: e.clientX - rect.left + 10,
          y: e.clientY - rect.top - 10
        });
      } else {
        setHoveredState(null);
      }
    };
    var handleMouseLeave = () => setHoveredState(null);
    container.addEventListener('mousemove', handleMouseMove);
    container.addEventListener('mouseleave', handleMouseLeave);
    return () => {
      container.removeEventListener('mousemove', handleMouseMove);
      container.removeEventListener('mouseleave', handleMouseLeave);
    };
  }, [hasImage]);
  var iconStates = getIconStates();
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "tw-bg-[#eff0f2]  md:tw-py-[96px]",
    "data-coverage-map": true,
    "data-figma-id": "4838:95873"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("style", null, "\n        .coverage-map-container path {\n          transition: fill 0.3s ease;\n          cursor: pointer;\n        }\n        .coverage-map-container path:hover {\n          filter: brightness(1.1);\n          stroke: #fff;\n          stroke-width: 2px;\n        }\n        .coverage-map-tooltip {\n          position: absolute;\n          pointer-events: none;\n          z-index: 100;\n          background: #1a3a5c;\n          color: white;\n          padding: 8px 12px;\n          border-radius: 6px;\n          font-size: 12px;\n          line-height: 1.4;\n          max-width: 300px;\n          box-shadow: 0 4px 12px rgba(0,0,0,0.15);\n        }\n        .coverage-map-tooltip::before {\n          content: '';\n          position: absolute;\n          bottom: -6px;\n          left: 20px;\n          border-left: 6px solid transparent;\n          border-right: 6px solid transparent;\n          border-top: 6px solid #1a3a5c;\n        }\n        .legend-item {\n          transition: opacity 0.2s ease;\n        }\n        .legend-item:hover {\n          opacity: 0.75;\n        }\n        .map-icon {\n          position: absolute;\n          transform: translate(-50%, -50%);\n          z-index: 20;\n        }\n\n        .map-icon:hover {\n          scale: 1.2;\n          filter: brightness(1.1);\n          transition: all 0.3s ease;\n        }\n\n        .map-icon:hover svg path {\n         filter: brightness(1.1);\n         stroke: #fff;\n        }\n\n        .map-icon,\n        .map-icon * {\n        pointer-events: all; /* Ensure div and children receive events */\n        }\n        .us-state-map {\n         width: 100% !important;\n        }\n\n        .view-map-btn {\n          position: relative;\n          overflow: hidden;\n        }\n        .view-map-btn span {\n          position: relative;\n          z-index: 1;\n          transition: color 0.3s ease-in-out;\n        }\n        .view-map-btn::before {\n          content: '';\n          position: absolute;\n          bottom: 0;\n          left: 0;\n          width: 100%;\n          height: 0;\n          background-color: #52C3C2;\n          transition: height 0.3s ease-in-out;\n          z-index: 0;\n          border-radius: inherit;\n        }\n        .view-map-btn:hover::before {\n          height: 100%;\n        }\n\n      "), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "mobile-image"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "tw-w-full tw-block md:tw-hidden tw-bg-white tw-order-1 md:tw-order-2 md:tw-flex-1 tw-mb-4 tw-border tw-border-slate-200",
    "data-figma-id": "4838:95876"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "tw-relative tw-w-full coverage-map-container",
    "data-figma-id": "4838:95877",
    ref: mapContainerRef
  }, hasImage ?
  /*#__PURE__*/
  // Show image if available
  react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "tw-relative tw-w-full"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("img", {
    src: imageUrl,
    alt: "Coverage Map",
    className: "tw-w-full tw-h-auto tw-rounded-lg"
  })) :
  /*#__PURE__*/
  // Show interactive map if no image
  react__WEBPACK_IMPORTED_MODULE_2___default().createElement((react__WEBPACK_IMPORTED_MODULE_2___default().Fragment), null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement((react_usa_map__WEBPACK_IMPORTED_MODULE_3___default()), {
    customize: statesCustomConfig(),
    defaultFill: GRAYED_COLOR,
    title: ""
  }), iconStates.map(_ref4 => {
    var stateCode = _ref4.stateCode,
      type = _ref4.type,
      pct = _ref4.pct;
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
      key: stateCode,
      className: "map-icon tw-flex tw-items-center tw-justify-center",
      style: {
        left: "".concat(pct.x, "%"),
        top: "".concat(pct.y, "%")
      },
      onMouseEnter: e => {
        var stateName = STATE_NAMES[stateCode] || stateCode;
        setHoveredState({
          name: stateName,
          coverages: []
        }); // markers show only state name
      },
      onMouseMove: e => {
        var rect = mapContainerRef.current.getBoundingClientRect();
        setTooltipPos({
          x: e.clientX - rect.left + 10,
          y: e.clientY - rect.top - 10
        });
      },
      onMouseLeave: () => setHoveredState(null)
    }, type === 'plus' && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
      className: "tw-w-4 tw-h-4 md:tw-w-[18px] md:tw-h-[18px] tw-rounded-full tw-bg-[#1a3a5c] tw-flex tw-items-center tw-justify-center tw-border tw-border-white/50"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("svg", {
      className: "tw-w-[10px] tw-h-[10px]",
      viewBox: "0 0 10 10",
      fill: "none"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("path", {
      d: "M5 1v8M1 5h8",
      stroke: "#4a9d9f",
      strokeWidth: "2",
      strokeLinecap: "round"
    }))), type === 'rotech' && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
      className: "tw-w-4 tw-h-4 md:tw-w-[18px] md:tw-h-[18px] tw-rounded-full tw-bg-[#0066b3] tw-flex tw-items-center tw-justify-center tw-border tw-border-white/50"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("span", {
      className: "tw-text-white tw-text-[8px] md:tw-text-[10px] tw-font-bold tw-leading-none"
    }, "R")));
  }), hoveredState && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "coverage-map-tooltip",
    style: {
      left: tooltipPos.x,
      top: tooltipPos.y,
      transform: 'translateY(-100%)'
    }
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "tw-font-bold tw-mb-1"
  }, hoveredState.name), hoveredState.coverages.map((coverage, idx) => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    key: idx,
    className: "tw-text-[11px] tw-opacity-90 tw-mb-0.5"
  }, "\u2022 ", coverage))))))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "section-container tw-px-5 md:tw-px-16"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "tw-flex tw-flex-col md:tw-flex-row md:tw-items-start md:tw-justify-between tw-gap-4 md:tw-gap-[45px]"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "tw-w-full tw-bg-white tw-hidden md:tw-block tw-p-5 tw-order-1 md:tw-order-2 md:tw-flex-1 tw-rounded-3xl tw-border tw-border-slate-200",
    "data-figma-id": "4838:95876"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "tw-relative tw-w-full coverage-map-container",
    "data-figma-id": "4838:95877",
    ref: mapContainerRef
  }, hasImage ?
  /*#__PURE__*/
  // Show image if available
  react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "tw-relative tw-w-full"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("img", {
    src: imageUrl,
    alt: "Coverage Map",
    className: "tw-w-full tw-h-auto tw-rounded-lg"
  })) :
  /*#__PURE__*/
  // Show interactive map if no image
  react__WEBPACK_IMPORTED_MODULE_2___default().createElement((react__WEBPACK_IMPORTED_MODULE_2___default().Fragment), null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement((react_usa_map__WEBPACK_IMPORTED_MODULE_3___default()), {
    customize: statesCustomConfig(),
    defaultFill: GRAYED_COLOR,
    title: ""
  }), iconStates.map(_ref5 => {
    var stateCode = _ref5.stateCode,
      type = _ref5.type,
      pct = _ref5.pct;
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
      key: stateCode,
      className: "map-icon tw-flex tw-items-center tw-justify-center",
      style: {
        left: "".concat(pct.x, "%"),
        top: "".concat(pct.y, "%")
      },
      onMouseEnter: e => {
        var stateName = STATE_NAMES[stateCode] || stateCode;
        setHoveredState({
          name: stateName,
          coverages: []
        }); // markers show only state name
      },
      onMouseMove: e => {
        var rect = mapContainerRef.current.getBoundingClientRect();
        setTooltipPos({
          x: e.clientX - rect.left + 10,
          y: e.clientY - rect.top - 10
        });
      },
      onMouseLeave: () => setHoveredState(null)
    }, type === 'plus' && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
      className: "tw-w-4 tw-h-4 md:tw-w-[18px] md:tw-h-[18px] tw-rounded-full tw-bg-[#1a3a5c] tw-flex tw-items-center tw-justify-center tw-border tw-border-white/50"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("svg", {
      className: "tw-w-[10px] tw-h-[10px]",
      viewBox: "0 0 10 10",
      fill: "none"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("path", {
      d: "M5 1v8M1 5h8",
      stroke: "#4a9d9f",
      strokeWidth: "2",
      strokeLinecap: "round"
    }))), type === 'rotech' && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
      className: "tw-w-4 tw-h-4 md:tw-w-[18px] md:tw-h-[18px] tw-rounded-full tw-bg-[#0066b3] tw-flex tw-items-center tw-justify-center tw-border tw-border-white/50"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("span", {
      className: "tw-text-white tw-text-[8px] md:tw-text-[10px] tw-font-bold tw-leading-none"
    }, "R")));
  }), hoveredState && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "coverage-map-tooltip",
    style: {
      left: tooltipPos.x,
      top: tooltipPos.y,
      transform: 'translateY(-100%)'
    }
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "tw-font-bold tw-mb-1"
  }, hoveredState.name), hoveredState.coverages.map((coverage, idx) => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    key: idx,
    className: "tw-text-[11px] tw-opacity-90 tw-mb-0.5"
  }, "\u2022 ", coverage)))))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "tw-w-full tw-px-5 tw-pb-11 md:tw-px-0 md:tw-pb-0 md:tw-pt-4 md:tw-w-[310px] md:tw-max-w-[330px] md:tw-sticky md:tw-top-0 tw-order-2 md:tw-order-1 tw-flex-shrink-0",
    "data-figma-id": "4838:96202"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "tw-flex tw-flex-col tw-gap-5",
    "data-figma-id": "4838:96203"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "tw-flex tw-flex-col",
    "data-figma-id": "4838:96206"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("h2", {
    className: "tw-font-bold tw-text-[30px] md:tw-text-[48px] tw-leading-[1.1] tw-tracking-[-1.2px] md:tw-tracking-[-1.92px] tw-text-heading-text tw-m-0",
    "data-figma-id": "4838:96207"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("span", {
    className: "tw-block"
  }, "Coverage"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("span", {
    className: "tw-block"
  }, "at-a-glance"))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "tw-flex tw-flex-col tw-gap-2",
    "data-figma-id": "4838:98088"
  }, LEGEND_ITEMS.map(item => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    key: item.id,
    className: "legend-item tw-flex tw-items-center tw-gap-2",
    "data-figma-id": "4838:9808".concat(LEGEND_ITEMS.indexOf(item) + 9)
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "tw-w-7 tw-h-7 tw-rounded tw-flex tw-items-center tw-justify-center tw-overflow-hidden tw-flex-shrink-0",
    style: {
      backgroundColor: item.color
    }
  }, item.hasIcon && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("svg", {
    className: "tw-w-[19px] tw-h-[14px]",
    viewBox: "0 0 19 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("rect", {
    x: "7",
    y: "0",
    width: "5",
    height: "14",
    rx: "2.5",
    fill: "#4a9d9f"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("rect", {
    x: "0",
    y: "4.5",
    width: "19",
    height: "5",
    rx: "2.5",
    fill: "#4a9d9f"
  })), item.hasLogo && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("svg", {
    className: "tw-w-[20px] tw-h-[20px]",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("text", {
    x: "3",
    y: "15",
    fill: "white",
    fontSize: "14",
    fontWeight: "bold",
    fontFamily: "Arial, sans-serif"
  }, "R"))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("span", {
    className: "tw-text-base tw-font-normal !tw-leading-[20px] !tw-break-words !tw-tracking-[-0.16px] tw-text-[#020618] tw-flex-1"
  }, item.label))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("a", {
    target: "_blank",
    href: "https://achomarketplace.myshopify.com/pages/coverage-map",
    className: "view-map-btn tw-mt-4 tw-inline-flex tw-items-center tw-justify-center tw-px-6 tw-py-3 tw-bg-[#092836] tw-text-white tw-text-base tw-font-bold tw-rounded-full tw-no-underline tw-min-h-[48px] tw-min-w-[100px]"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("span", null, "View Map"))))))));
}

/***/ },

/***/ "./js/sections/coverage-map.js"
/*!*************************************!*\
  !*** ./js/sections/coverage-map.js ***!
  \*************************************/
(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

/* harmony import */ var JsComponents_react_wrapper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! JsComponents/react-wrapper */ "./js/components/react-wrapper.js");
/* harmony import */ var JsComponents_CoverageMap_jsx__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! JsComponents/CoverageMap.jsx */ "./js/components/CoverageMap.jsx");
/**
 * Coverage Map Section Entry Point
 * Interactive USA map showing AdaptHealth coverage by state
 */




// Initialize React component
(0,JsComponents_react_wrapper__WEBPACK_IMPORTED_MODULE_0__["default"])(JsComponents_CoverageMap_jsx__WEBPACK_IMPORTED_MODULE_1__["default"], '[data-coverage-map-react]', '[data-coverage-map-props]');

// Re-initialize on Shopify section load (for theme editor)
document.addEventListener('shopify:section:load', () => {
  (0,JsComponents_react_wrapper__WEBPACK_IMPORTED_MODULE_0__["default"])(JsComponents_CoverageMap_jsx__WEBPACK_IMPORTED_MODULE_1__["default"], '[data-coverage-map-react]', '[data-coverage-map-props]');
});

/***/ }

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	const __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		const cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		const module = __webpack_module_cache__[moduleId] = {
/******/ 			id: moduleId,
/******/ 			loaded: false,
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		if (!(moduleId in __webpack_modules__)) {
/******/ 			delete __webpack_module_cache__[moduleId];
/******/ 			const e = new Error("Cannot find module '" + moduleId + "'");
/******/ 			e.code = 'MODULE_NOT_FOUND';
/******/ 			throw e;
/******/ 		}
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		const deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn) => {
/******/ 			if(chunkIds) {
/******/ 				deferred.push([chunkIds, fn]);
/******/ 				return;
/******/ 			}
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				let [chunkIds, fn] = deferred[i];
/******/ 				let fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if (__webpack_require__.O.j(chunkIds[j])) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					const r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = (module) => {
/******/ 		const getter = module && module.__esModule ?
/******/ 			() => (module['default']) :
/******/ 			() => (module);
/******/ 		__webpack_require__.d(getter, { a: getter });
/******/ 		return getter;
/******/ 	};
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	// define getter/value functions for harmony exports
/******/ 	__webpack_require__.d = (exports, definition) => {
/******/ 		for(var key in definition) {
/******/ 			if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 				Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 			}
/******/ 		}
/******/ 	};
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	__webpack_require__.g = (function() {
/******/ 		if (typeof globalThis === 'object') return globalThis;
/******/ 		try {
/******/ 			return this || new Function('return this')();
/******/ 		} catch (e) {
/******/ 			if (typeof window === 'object') return window;
/******/ 		}
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop));
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = (exports) => {
/******/ 		Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/ 	
/******/ 	/* webpack/runtime/node module decorator */
/******/ 	__webpack_require__.nmd = (module) => {
/******/ 		module.paths = [];
/******/ 		if (!module.children) module.children = [];
/******/ 		return module;
/******/ 	};
/******/ 	
/******/ 	/* webpack/runtime/set anonymous default export name */
/******/ 	// set .name for anonymous default exports per ES spec
/******/ 	// skipped when the property is non-configurable (pre-ES2015 engines),
/******/ 	// where Object.defineProperty would throw
/******/ 	__webpack_require__.dn = (x) => {
/******/ 		var descriptor = Object.getOwnPropertyDescriptor(x, "name");
/******/ 		if (!descriptor || (!descriptor.writable && descriptor.configurable)) Object.defineProperty(x, "name", { value: "default", configurable: true });
/******/ 	};
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		const installedChunks = {
/******/ 			"coverage-map": 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		const webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			let [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		const chunkLoadingGlobal = self["webpackChunkshoptrade_Shopify_Development"] = self["webpackChunkshoptrade_Shopify_Development"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	let __webpack_exports__ = __webpack_require__.O(undefined, ["vendors","shared"], () => (__webpack_require__("./js/sections/coverage-map.js")))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;